module.exports = __webpack_public_path__ + "static/media/process-service-quality.f087d300.svg";